/**
 * Avalara © 2017
 * file: engines/opus_ui/src/search/ResultsFacetBar.js
 */

import React, { Component } from 'react';
import './ResultsFacetBar.css';
import { connect } from 'react-redux';

class ResultsFacetBar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // console.log('handleClick: ', e.target);
  }

  render() {
    const facetNames = [
      'Summary',
      // "Customers",
      // "Transactions",
      // "Obligations",
      // "Invoices",
      // "Payments",
      // "Delivery Systems",
      // "Usage",
      // "Free Stuff"
    ];
    const facet = this.props.facet ? this.props.facet : facetNames[0];

    return (
      <div className="ResultsFacetBar">
        {facetNames.map((sectionName, index, array) => {
          return (
            <div
              key={index}
              className={
                sectionName === facet
                  ? 'ResultsFacetBarItem Selected'
                  : 'ResultsFacetBarItem'
              }
              onClick={(e) => {
                this.handleClick(e);
              }}
            >
              {sectionName}
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(ResultsFacetBar);
